import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';

@Injectable()
export class IonicMessageServiceProvider {
	toast;

	constructor(private toastCtrl: ToastController) {}

	private messageTypes = {
		e: 'error',
		s: 'success',
		i: 'info',
		w: 'warning'
	};

	showToaster(msgObject) {
		const { messageType, title, text } = msgObject;
		const cssClass = `ion-toast-${this.messageTypes[messageType]}`;
		const message = `${title}\n${text}`;

		try {
			this.toast.dismiss();
		} catch (error) {
			console.error(error);
		}

		this.toast = this.toastCtrl.create({
			message,
			cssClass,
			duration: 2500,
			position: 'top',
			dismissOnPageChange: false
		});

		this.toast.onDidDismiss(() => {
			// console.log('Dismissed toast');
		});

		this.toast.present();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./mobile/src/providers/ionic-message-service/ionic-message-service.ts